import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import Label from '../../components/Label';

// the `data` prop is an object with the shape:
// {
//   errors?: Errors
//   [name]: any
// }

class StoreDropdown extends Component {
  render() {
    const { name, title, lists, data, onChange, required } = this.props;
    const stores = lists.stores.edges.map((e) => e.node);

    return (
      <div className="store-field">
        <Label name={name} title={title} errors={data.validationErrors} />
        <select
          id={name}
          value={data[name]}
          onChange={onChange}
          required={required}
        >
          <option disabled="disabled" defaultValue value="">
            {' '}
            -- select a store --{' '}
          </option>
          {stores.map((store, i) => (
            <option value={store.id} key={i}>
              {store.name}
            </option>
          ))}
        </select>
      </div>
    );
  }
}

export default createFragmentContainer(StoreDropdown, {
  lists: graphql`
    fragment StoreDropdown_lists on Lists {
      stores(first: 1000, active: false) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  `,
});

StoreDropdown.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  lists: PropTypes.shape().isRequired,
  data: PropTypes.shape().isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
};

StoreDropdown.defaultProps = {
  required: false,
};
